import styled from 'styled-components';
import Spinner from '../Global/Atomics/Spinner';
import { WidgetCard } from '../Global/Atomics/WidgetCard';
import { AreaChartComponent } from '../Global/Charts/AreaChartComponent';
import CustomIcon from '../Global/Icons/CustomIcon';
import { Text } from '../Global/Atomics/Text';
import Theme from '../../styles/Theme/Theme';

export const TwoDaysConsumeAreaChartWidget = (props) => {
    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} justifyContent='space-between'>
            {/* {proccessData !== null ? */}
            <>
                <div style={{ display: "flex", alignItems: 'flex-end' }}><CustomIcon icon={props?.block?.icon ?? 'Bolt'} iconSize='sm' color="#008000" strokeWidth='1'/><Text marginLeft='0.4vw'  fontSize='text_lg' fontWeight='medium' color='black'>{props?.block?.title ?? 'Pollution Energy'}</Text></div>
                <div style={{ display: 'flex', height: '70%'}}>
                    <div style={{width: props?.block?.big ? '40%' : '100%'}}>
                        <AreaChartComponent data={props?.block?.data} big={props?.block?.big} chartLabel={props?.block?.chartLabel}/>
                    </div>
                    <div style={{ display: props?.block?.big ? 'flex' : 'none', flexDirection: 'column', alignSelf: 'center', marginLeft: '1vw'}}>
                        <Text color='black' margin='0' fontSize='text_xs'>{props?.block?.unit ?? ''} today</Text>
                        <Text color='black' margin='0' fontSize='text_xl' weight="regular" fontWeight='bold'>{props?.block?.value ?? 0}</Text>
                        <div style={{ display: 'flex', alignItems: 'end' }}><CustomIcon icon={"QualityGood"} iconSize='xs'/><Text margin='0' fontSize='text_xs' color='#4cb775'>{props?.block?.difference ?? '0%'}</Text><Text color='gray' marginLeft='5px' fontSize='text_xs'>less than yesterday</Text></div>
                    </div>
                </div>
            </>
            {/* : <div style={{height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}><Spinner stroke="green"/></div>} */}
        </WidgetCard>
    );
};